import api from './axiosConfig';
export const register      = (data)  => api.post('/api/v1/auth/register',        data);
export const login         = (data)  => api.post('/api/v1/auth/login',            data);
export const logout        = ()      => api.post('/api/v1/auth/logout');
export const getMe         = ()      => api.get('/api/v1/auth/me');
export const updateProfile = (data)  => api.put('/api/v1/auth/profile',           data);
export const forgotPassword= (data)  => api.post('/api/v1/auth/forgot-password',  data);
export const resetPassword  = (data)  => api.post('/api/v1/auth/reset-password',   data);
export const updatePassword = (data)  => api.put('/api/v1/auth/password',           data);

// Aliases used by auth pages
export const loginUser    = login;
export const registerUser = register;
